// extracted by mini-css-extract-plugin
export default {"snapContainer":"Home_snapContainer__96lNg","snapSection":"Home_snapSection__4Y1mA"};